import {
  fetchAll,
  addExtract,
  show,
  edit,
  removeOs,
  fetchFinishedOs,
  fetchFinishedOsFiltered,
  fetchPrintExtract,
  uploadPaymentVoucher,
  sendEmail
} from '@/api/extract'

const state = {
  all: [],
  isLoading: false,
  extractById: null,
  finishedOsFiltered: [],
  finishedOs: [],
  structureExtractToPrint: undefined
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const extract = await show(id)
      commit('setExtractById', extract)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }, params) {
    try {
      const extracts = await fetchAll(params)
      commit('setAll', extracts)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFinishedOs({ dispatch, commit}) {
    try {
      const finishedOs = await fetchFinishedOs()
      commit('setFinishedOs', finishedOs.rows)
    } catch (error) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFinishedOsFiltered({ dispatch, commit }, queries) {
    try {
      const finishedOsFiltered = await fetchFinishedOsFiltered(queries)
      commit('setFinishedOsFiltered', finishedOsFiltered)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchPrintExtract({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const data = await fetchPrintExtract(id)

      commit('setStructureExtractToPrint', data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {

    try {
      await addExtract(data)
      return true
    } catch (e) {
      // dispatch('notify/error', e, { root: true })
      return false
    }

  },

  async edit ({ dispatch, commit }, data) {
    try {
      await edit(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
      return false
    }
  },

  async removeOs ({dispatch, commit}, id) {
    try {
      await removeOs(id)
      return true
    } catch (e) {
      return false
    }
  },

  async uploadPaymentVoucher ({ dispatch, commit }, data) {
    try {
      await uploadPaymentVoucher(data)
      return true
    } catch (error) {
      dispatch('notify/error', error, { root: true })
      return false
    }
  },

  async sendEmail({ dispatch }, id) {
    try {
      await sendEmail(id)
      return true
    } catch (error) {
      dispatch('notify/error', error, { root: true })
      return false
    }
  },

  clearFinishedOsFiltered({ commit }) {
    commit('clearFinishedOsFiltered')
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.extractById = null
  },

  setAll (state, extracts) {
    state.all = extracts
  },

  setFinishedOs(state, os) {
    state.finishedOs = os
  },

  setFinishedOsFiltered(state, finishedOsFiltered) {
    state.finishedOsFiltered = finishedOsFiltered
  },

  clearFinishedOsFiltered(state) {
    state.finishedOsFiltered = []
  },

  setStructureExtractToPrint(state, structure) {
    state.structureExtractToPrint = structure
  },

  setExtractById (state, extract) {
    state.extractById = extract
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
